import script from "./AddTenant.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddTenant.vue?vue&type=script&lang=ts&setup=true"

import "./AddTenant.vue?vue&type=style&index=0&id=493130df&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-493130df"]])

export default __exports__